<template>
  <div v-if="!item.hidden" class="menu-wrapper">
    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <item :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)" :title="onlyOneChild.meta.title" :level="level" />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <div :style="{paddingLeft: level === 2 ? '12px' : ''}">
          <item v-if="item.meta" class="submenuTitle" :icon="item.meta && item.meta.icon" :title="item.meta.title" :level="level" />
        </div>
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
        :level="level+1"
        style="padding-left: 7px;"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import { isExternal } from '@/utils/validate'
import Item from './Item'
import AppLink from './Link'
import FixiOSBug from './FixiOSBug'
export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    },
    level: {
      type: Number
    }
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null
    return {}
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
.menu-wrapper{
  >a{
    ::v-deep {
      .el-menu-item{
        height: 40px;
        line-height: 40px;
        color: rgba(255, 255, 255, 1);
        // letter-spacing: 2px;
        font-size: $sideBarSize;
        // padding: 0 0 0 50px !important;
        padding: 0 0 0 20px !important;
      }
    }
    ::v-deep .el-menu-item.is-active {
      background-color: $selectBackground !important;
      color: $selectFont !important;
      // font-weight: 400;
      // span {
      //   color: $selectFont !important;
      // }
      // &:hover{
      //   background-color: $selectBackground !important;
      //   color: $selectFont;
      // }
    }
  }
  ::v-deep .el-submenu__icon-arrow {
          right:15px;
      }
}
.menu-wrapper.nest-menu{
  ::v-deep .el-menu-item{
      padding: 0 0 0 50px !important;
  }
}
//.el-submenu.is-opened{
//  ::v-deep .el-submenu__title{
//    // background-color:  $subMenuBg !important;
//    color:  $subMenuActiveText !important;
//    // &:hover{
//    //   span{
//    //       color: $subMenuHover !important;
//    //     }
//    // }
//  }
//}
::v-deep .el-submenu__title{
    line-height: 40px;
    height: 40px;
    font-size: $sideBarSize;
    padding: 0 0 0 21px !important;
    >span{
      // letter-spacing: 2px;
      font-weight:400;
    }
  }
.el-scrollbar__view{
  >.el-menu{
    // >.menu-wrapper:nth-child(1){
    //     margin-top: 16px;
    // }
  >.menu-wrapper{
    background-color: rgba(37, 44, 54, 1);
    >a{
      >::v-deep .el-menu-item{
       >span{
          // height: 56px;
          // letter-spacing: 2px;
          // font-size: 20px;
          // padding: 0 0 0 20px !important;
          font-weight:400;
       }
      }
    }
  }
}
}

</style>
